module.exports = __webpack_public_path__ + "img/712.9dcc7165.jpg";